// ---------------------------------------------------------------------------
// PWA Caisse Tablette — Table button (grid item)
// ---------------------------------------------------------------------------

import type { Table } from '@/lib/types';

interface TableButtonProps {
  table: Table;
  isSelected: boolean;
  onClick: () => void;
}

const STATE_STYLES: Record<string, string> = {
  libre: 'bg-table-libre/20 border-table-libre text-table-libre',
  reservee: 'bg-table-reservee/20 border-table-reservee text-table-reservee',
  occupee: 'bg-table-occupee/20 border-table-occupee text-table-occupee',
  verrouillee: 'bg-table-verrouillee/20 border-table-verrouillee text-table-verrouillee',
};

export default function TableButton({ table, isSelected, onClick }: TableButtonProps) {
  const stateClass = STATE_STYLES[table.state] ?? 'bg-surface-card border-gray-600 text-gray-300';

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex flex-col items-center justify-center gap-1 p-3 rounded-xl border-2 min-h-[72px] transition-all ${stateClass} ${
        isSelected ? 'ring-2 ring-accent ring-offset-1 ring-offset-surface' : ''
      }`}
    >
      <span className="text-sm font-semibold">{table.name || table.id}</span>
      <span className="text-xs opacity-70">{table.capacity}p</span>
    </button>
  );
}
